import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-10badbdc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "p-grid"
}
const _hoisted_2 = { class: "p-col-12" }
const _hoisted_3 = { class: "p-text-center" }
const _hoisted_4 = { class: "p-text-center" }
const _hoisted_5 = { class: "p-text-center" }
const _hoisted_6 = {
  key: 1,
  class: "p-grid"
}
const _hoisted_7 = { class: "p-col-12" }
const _hoisted_8 = { class: "p-text-center" }
const _hoisted_9 = { class: "p-text-center" }
const _hoisted_10 = { class: "p-grid" }
const _hoisted_11 = { class: "p-fluid" }
const _hoisted_12 = { class: "p-field p-mb-4" }
const _hoisted_13 = { class: "p-field p-mb-4" }
const _hoisted_14 = { class: "p-field p-mb-4" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_17 = {
  key: 0,
  class: "p-field p-mb-4"
}
const _hoisted_18 = { class: "p-field" }
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_21 = {
  key: 1,
  class: "p-field-checkbox p-mb-4 center-checkbox"
}
const _hoisted_22 = { for: "callBack" }
const _hoisted_23 = {
  key: 0,
  class: "p-col-12 p-md-6 p-text-center"
}
const _hoisted_24 = ["innerHTML"]
const _hoisted_25 = { class: "p-text-center" }
const _hoisted_26 = { class: "property-level" }
const _hoisted_27 = { key: 2 }
const _hoisted_28 = {
  key: 3,
  class: "p-text-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Divider = _resolveComponent("Divider")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Button = _resolveComponent("Button")!
  const _component_progress_spinner = _resolveComponent("progress-spinner")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.inCoverage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.labels.DETAILS_TITLE), 1),
            _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.labels.DETAILS_LINE_1), 1),
            _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.labels.DETAILS_LINE_2), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.inCoverage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("h1", _hoisted_8, _toDisplayString(_ctx.labels.DETAIL_NO_COVERAGE_TITLE), 1),
            _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.labels.DETAILS_NO_COVERAGE_LINE_1), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_Divider, { class: "p-my-4" }),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", {
        class: _normalizeClass(["p-col-12", { 'p-md-6': !_ctx.is_disconnection, 'disconnection-form': _ctx.is_disconnection }])
      }, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_InputText, {
              placeholder: _ctx.labels.DETAILS_LABEL_CONTACT_NAME,
              id: "contact_name",
              modelValue: _ctx.contact_name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.contact_name) = $event)),
              class: _normalizeClass({'p-invalid': _ctx.validationErrors.contact_name && _ctx.submitted})
            }, null, 8, ["placeholder", "modelValue", "class"]),
            _withDirectives(_createElementVNode("small", { class: "p-error" }, _toDisplayString(_ctx.labels.DETAILS_ERROR_CONTACT_NAME), 513), [
              [_vShow, _ctx.validationErrors.contact_name && _ctx.submitted]
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_InputText, {
              placeholder: _ctx.labels.DETAILS_LABEL_CONTACT_EMAIL,
              id: "contact_email",
              modelValue: _ctx.contact_email,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.contact_email) = $event)),
              class: _normalizeClass({'p-invalid': _ctx.validationErrors.contact_email && _ctx.submitted})
            }, null, 8, ["placeholder", "modelValue", "class"]),
            _withDirectives(_createElementVNode("small", { class: "p-error" }, _toDisplayString(_ctx.labels.DETAILS_ERROR_CONTACT_EMAIL), 513), [
              [_vShow, _ctx.validationErrors.contact_email && _ctx.submitted]
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_InputText, {
              placeholder: _ctx.labels.DETAILS_LABEL_CONTACT_CELLPHONE,
              id: "contact_cellphone",
              modelValue: _ctx.contact_cellphone,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.contact_cellphone) = $event)),
              class: _normalizeClass({'p-invalid': _ctx.validationErrors.contact_cellphone && _ctx.submitted})
            }, null, 8, ["placeholder", "modelValue", "class"]),
            (_ctx.inCoverage)
              ? (_openBlock(), _createElementBlock("small", _hoisted_15, _toDisplayString(_ctx.labels.DETAILS_HINT_CONTACT_CELLPHONE), 1))
              : _createCommentVNode("", true),
            _hoisted_16,
            _withDirectives(_createElementVNode("small", { class: "p-error" }, _toDisplayString(_ctx.labels.DETAILS_ERROR_CONTACT_CELLPHONE), 513), [
              [_vShow, _ctx.validationErrors.contact_cellphone && _ctx.submitted]
            ])
          ]),
          (_ctx.inCoverage)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _createVNode(_component_Dropdown, {
                  modelValue: _ctx.contract_term,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.contract_term) = $event)),
                  optionLabel: "name",
                  optionValue: "code",
                  options: _ctx.terms,
                  placeholder: "Select a contract term"
                }, null, 8, ["modelValue", "options"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_18, [
            _createVNode(_component_Calendar, {
              id: "moving_date",
              placeholder: (_ctx.is_disconnection) ? _ctx.labels.DETAILS_DISCONNECTION_DATE : _ctx.labels.DETAILS_LABEL_MOVING_DATE,
              modelValue: _ctx.moving_date,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.moving_date) = $event)),
              showIcon: true,
              touchUI: _ctx.isTouch,
              minDate: _ctx.minDateValue,
              maxDate: _ctx.maxDateValue,
              class: _normalizeClass({'p-invalid': _ctx.validationErrors.moving_date && _ctx.submitted})
            }, null, 8, ["placeholder", "modelValue", "touchUI", "minDate", "maxDate", "class"]),
            (_ctx.inCoverage)
              ? (_openBlock(), _createElementBlock("small", {
                  key: 0,
                  innerHTML: _ctx.labels.DETAILS_HINT_MOVING_DATE
                }, null, 8, _hoisted_19))
              : _createCommentVNode("", true),
            _hoisted_20,
            _withDirectives(_createElementVNode("small", { class: "p-error" }, _toDisplayString(_ctx.labels.DETAILS_ERROR_MOVING_DATE), 513), [
              [_vShow, _ctx.validationErrors.moving_date && _ctx.submitted]
            ])
          ]),
          (!_ctx.inCoverage)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                _createVNode(_component_Checkbox, {
                  id: "callBack",
                  modelValue: _ctx.call_back,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.call_back) = $event)),
                  binary: true
                }, null, 8, ["modelValue"]),
                _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.labels.DETAILS_NO_COVERAGE_LABEL_CALLBACK), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ], 2),
      (_ctx.inCoverage)
        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
            _createElementVNode("h2", {
              class: "p-text-center",
              innerHTML: _ctx.labels.DETAILS_INSTALLERS_TITLE
            }, null, 8, _hoisted_24),
            _createElementVNode("p", _hoisted_25, [
              _createElementVNode("strong", null, _toDisplayString(_ctx.labels.DETAILS_INSTALLERS_SUBTITLE), 1)
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createVNode(_component_Button, {
                label: _ctx.labels.DETAILS_INSTALLERS_LABEL_SINGLE,
                class: _normalizeClass(["p-button-raised p-button-lg p-m-2 p-button-secondary", {
              'p-button-secondary': _ctx.property_levels === 1,
              'p-button-text': _ctx.property_levels !== 1
            }]),
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.submitPropertyDetail('single')))
              }, null, 8, ["label", "class"]),
              _createVNode(_component_Button, {
                label: _ctx.labels.DETAILS_INSTALLERS_LABEL_MULTI,
                class: _normalizeClass(["p-button-raised p-button-lg p-m-2 p-button-secondary", {
              'p-button-secondary': _ctx.property_levels === 2,
              'p-button-text': _ctx.property_levels !== 2
            }]),
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.submitPropertyDetail('multi')))
              }, null, 8, ["label", "class"])
            ]),
            _withDirectives(_createElementVNode("small", { class: "p-error" }, _toDisplayString(_ctx.labels.DETAILS_INSTALLERS_ERROR), 513), [
              [_vShow, _ctx.validationErrors.property_levels && _ctx.submitted]
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_Divider, { class: "p-my-4" }),
    (!_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
          _createVNode(_component_Button, {
            class: "p-d-block p-mx-auto",
            label: _ctx.labels.DETAILS_BUTTON_NEXT,
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.nextPage()))
          }, null, 8, ["label"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
          _createVNode(_component_progress_spinner, { class: "p-mx-auto" })
        ]))
      : _createCommentVNode("", true)
  ]))
}